import { Leaf, MapPin, Calendar } from "@phosphor-icons/react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { API } from "@/config/constants";

const EntryCard = ({ entry, onClick }) => {
  const photoUrl = entry.photos?.[0]?.storage_path
    ? `${API}/photos/${entry.photos[0].storage_path}`
    : null;

  return (
    <Card
      className="entry-card cursor-pointer card-hover bg-white border-[#D2C2B3] shadow-[0_6px_24px_rgba(50,50,50,0.5)]"
      onClick={onClick}
      data-testid={`entry-card-${entry.id}`}
    >
      {photoUrl && (
        <div className="aspect-square overflow-hidden bg-white relative group">
          <img
            src={photoUrl}
            alt={entry.title}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <p className="text-white font-medium text-sm truncate">{entry.title}</p>
              {entry.location && (
                <p className="text-white/70 text-xs flex items-center gap-1">
                  <MapPin size={10} />{entry.location}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-2">
          <h3 className="font-heading text-xl font-semibold text-[#2E332B] line-clamp-1">{entry.title}</h3>
          {entry.species_identified?.length > 0 && (
            <Leaf size={20} weight="duotone" className="text-[#C25A3C] flex-shrink-0" />
          )}
        </div>
        <p className="text-sm text-[#7C8068] line-clamp-2 mb-3">{entry.content}</p>
        <div className="flex items-center gap-2 text-xs text-[#7C8068] mb-2">
          {entry.location && (
            <span className="flex items-center gap-1">
              <MapPin size={14} weight="duotone" />
              {entry.location}
            </span>
          )}
          <span className="flex items-center gap-1">
            <Calendar size={14} weight="duotone" />
            {new Date(entry.created_at).toLocaleDateString()}
          </span>
        </div>
        {entry.tags?.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {entry.tags.slice(0, 3).map(tag => (
              <Badge
                key={tag}
                variant="secondary"
                className="bg-[#EAE7DE] text-[#2E332B] hover:bg-[#D2C2B3] text-xs"
              >
                {tag}
              </Badge>
            ))}
            {entry.tags.length > 3 && (
              <Badge variant="secondary" className="bg-[#EAE7DE] text-[#7C8068] text-xs">
                +{entry.tags.length - 3}
              </Badge>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default EntryCard;
